export default __webpack_public_path__ + "4eb6d358492ca63c30ab87ea5f1690ad.svg";